export default __webpack_public_path__ + "static/media/BE.be911fc6.svg";